import numeral from 'numeraljs';
import PosActions from '../../../actions/PosActions';
import NotificationActions from '../../../actions/NotificationActions';

import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';

import { endPoints as EndPoints } from '../../../constants/PosConstants';
import Toggle from '../../form/Toggle.react';
import AjaxPromises from '../../../utils/AjaxPromises';
import CheckoutInputPrice from '../../pos/checkout/CheckoutInputPrice.react';

class ChangePaymentTypeForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            initialCash : {
                str : '',
                int : 0,
            },
            initialDebit   : {
                str : '',
                int : 0,
            },
            initialElectronic: {
                str: '',
                int: 0,
                type: '',
            },
            initialCreditcard: {
                str: '',
                int: 0,
            },
            initialCheck: {
                str: '',
                int: 0,
            },
            initialTotalDueCustomer: {
                str: '',
                int: 0,
            },
            newCash    : {
                str : '',
                int : 0,
            },
            newDebit   : {
                str : '',
                int : 0,
            },
            newElectronic: {
                str: '',
                int: 0,
                type: '',
            },
            newCreditcard: {
                str: '',
                int: 0,
            },
            newCheck: {
                str: '',
                int: 0,
            },
            newTotalDueCustomer: {
                str: '',
                int: 0,
            },
        };

        this.submitChange = this.submitChange.bind(this);
        this.validateNewPayment = this.validateNewPayment.bind(this);
        this.loadInitialPrices = this.loadInitialPrices.bind(this);
        this.formatState = this.formatState.bind(this);

        this.loadInitialPrices(props.transaction.PosId);
    }


    formatState() {
        return {
            NewDebitPaid: this.state.newDebit.int / 100,
            NewCashPaid: this.state.newCash.int / 100,
            NewCreditPaid: this.state.newCreditcard.int / 100,
            NewCheckPaid: this.state.newCheck.int / 100,
            NewTotalDueCustomer: this.state.newTotalDueCustomer.int / 100,
            ShipmentId: this.props.transaction.PosId,
        };
    }

    intValue(value) {
        if (value) {
            let str = numeral(value).format('0.00');
            return parseInt(str.replace('.', ''));
        } else {
            return 0;
        }
    }

    loadInitialPrices(id) {
        let self = this;
        AjaxPromises.POST(EndPoints.GET_TRANSACTION_PAYMENT, UserStore.getApiData({ ShipmentId: id }))
        .then(res => {
            if(!res.Result) {
                NotificationActions.error('Failed to get payment details for transaction');
                return;
            }
            self.setState({ 
                initialCash : {
                    str : res.Data.CashPaid.toString(),
                    int : this.intValue(res.Data.CashPaid),
                },
                initialDebit   : {
                    str : res.Data.DebitPaid.toString(),
                    int : this.intValue(res.Data.DebitPaid),
                },
                initialElectronic: {
                    str: '',
                    int: 0,
                    type: '',
                },
                initialCreditcard: {
                    str: res.Data.CreditPaid.toString(),
                    int: this.intValue(res.Data.CreditPaid),
                },
                initialCheck: {
                    str: res.Data.CheckPaid.toString(),
                    int: this.intValue(res.Data.CheckPaid),
                },
                initialTotalDueCustomer: {
                    str: res.Data.TotalDueCustomer.toString(),
                    int: res.Data.TotalDueCustomer * 100,
                },

                newCash: {
                    str : res.Data.CashPaid.toString(),
                    int : this.intValue(res.Data.CashPaid),
                },
                newDebit   : {
                    str : res.Data.DebitPaid.toString(),
                    int : this.intValue(res.Data.DebitPaid),
                },
                newElectronic: {
                    str: '',
                    int: 0,
                    type: '',
                },
                newCreditcard: {
                    str: res.Data.CreditPaid.toString(),
                    int: this.intValue(res.Data.CreditPaid),
                },
                newCheck: {
                    str: res.Data.CheckPaid.toString(),
                    int: this.intValue(res.Data.CheckPaid),
                },
                newTotalDueCustomer: {
                    str: res.Data.TotalDueCustomer.toString(),
                    int: res.Data.TotalDueCustomer * 100,
                },
            });

        });
    }

    submitChange() {
        if(this.state.loading || !this.validateNewPayment()) {
            return;
        } 

        this.setState({ loading: true});
        AjaxPromises.POST(EndPoints.SET_TRANSACTION_PAYMENT, 
            UserStore.getApiData(this.formatState()))
        .then(res => {
            this.setState({ loading: false});
            if(!res.Result) {
                NotificationActions.error(res.Message);
                return;
            }
            
            this.props.onPaymentChange();

        }).catch(err => {
            this.setState({ loading: false});
        });
       
    }

    validateNewPayment() {
        var initPayment = 
        this.state.initialCash.int + 
        this.state.initialDebit.int +
        this.state.initialElectronic.int +
        this.state.initialCreditcard.int +
        this.state.initialCheck.int -
        this.state.initialTotalDueCustomer.int;

        var newPayment = 
        this.state.newCash.int + 
        this.state.newDebit.int +
        this.state.newElectronic.int +
        this.state.newCreditcard.int +
        this.state.newCheck.int -
        this.state.newTotalDueCustomer.int;
        return initPayment === newPayment;
    }

    render() {

        let location = UserStore.getState().selectedLocation;
        return (
            <div className='popup popup__transparent'>
                <div className='popup__content checkout'>
                    <div className='change-payment__title'>
                        Change Payment Type
                    </div>

                     <div className='change-payment__question'>
                        Current Payments
                    </div>

                    
                    <CheckoutInputPrice
                        disabled
                        title='CASH PAID'
                        icon='dollar-sign'
                        value={this.state.initialCash}
                        onChange={cash => {  }} 
                        />

                    { location.CheckOutDebit &&
                        <CheckoutInputPrice
                            disabled
                            title='DEBIT PAID'
                            icon='credit-card'
                            value={this.state.initialDebit}
                            onChange={debit => {  }} 
                            />
                    }

                    { (location.CheckOutCreditCard) &&
                        <CheckoutInputPrice
                            title='CREDIT PAID'
                            icon='credit-card'
                            value={this.state.initialCreditcard}
                            onChange={creditcard => { }} 
                            />
                    }

                    { (location.CheckOutCheck) &&
                        <CheckoutInputPrice
                            title='CHECK'
                            icon='money-bill-alt'
                            value={this.state.initialCheck}
                            onChange={check => {  }} 
                            />
                    }

                    <CheckoutInputPrice
                        disabled
                        title='CHANGE'
                        icon='dollar-sign'
                        value={this.state.initialTotalDueCustomer}
                        onChange={totalDue => {  }} 
                        />

                    <div className='change-payment__question'>
                        New Payment Type
                    </div>

                    <div className='change-payment__answer'>

                        <CheckoutInputPrice
                                title='CASH PAID'
                                icon='dollar-sign'
                                value={this.state.newCash}
                                onChange={newCash => { 
                                    this.setState({ newCash: newCash }); }} />

                        { location.CheckOutDebit &&
                            <CheckoutInputPrice
                                title='DEBIT PAID'
                                icon='credit-card'
                                value={this.state.newDebit}
                                onChange={newDebit => { this.setState({ newDebit: newDebit }); }} />
                        }

                        { (location.CheckOutCreditCard) &&
                            <CheckoutInputPrice
                                title='CREDIT PAID'
                                icon='credit-card'
                                value={this.state.newCreditcard}
                                onChange={newCreditcard => { this.setState({ newCreditcard: newCreditcard }); }} />
                        }

                        { (location.CheckOutCheck) &&
                            <CheckoutInputPrice
                                title='CHECK'
                                icon='money-bill-alt'
                                value={this.state.newCheck}
                                onChange={newCheck => { 
                                    
                                    this.setState({ newCheck: newCheck }); }} />
                        }

                        <CheckoutInputPrice
                            title='CHANGE'
                            icon='dollar-sign'
                            value={this.state.newTotalDueCustomer}
                            onChange={newTotalDueCustomer => { 
                                this.setState({ newTotalDueCustomer: newTotalDueCustomer }); }} />                        
                    </div>

                    <div
                        className='change-payment__back'
                        onClick={() => { this.props.onBack(); }}>

                        BACK
                    </div>

                    <div
                        className={'change-payment__submit '+(!this.validateNewPayment() ? 'btn-green__disabled' : '')}
                        onClick={this.submitChange} disabled={this.state.loading || !this.validateNewPayment()}>

                        { !this.state.loading ? 'OK' : <i className="fa fa-spinner fa-pulse" aria-hidden="true" /> }
                    </div>
                </div>
            </div>
        );
    }
}

export default ChangePaymentTypeForm;


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/ChangePaymentTypeForm.react.jsx